var _circle, _line, _circle2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgBrowseEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6668,
    r: 20,
    fill: "#CED2E5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.7218,
    y1: 30.7205,
    x2: 16.0551,
    y2: 23.3872,
    stroke: "black",
    strokeWidth: 1.73333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0013,
    cy: 18.6667,
    r: 7.8,
    stroke: "black",
    strokeWidth: 1.73333
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseEvent);
export default __webpack_public_path__ + "static/media/browse-event.bb520e79c2a80ead196f8ba0b151f972.svg";
export { ForwardRef as ReactComponent };